var DialogReallocateMaintenanceModule = /** @class */ (function () {
    function DialogReallocateMaintenanceModule() {
    }
    return DialogReallocateMaintenanceModule;
}());
export { DialogReallocateMaintenanceModule };
